import React, { forwardRef, useRef, useState, Children, isValidElement, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import useIsomorphicLayoutEffect from '../../../hooks/bundle.esm.js';
import usePortal from '../../../hooks/bundle.esm2.js';
import useWindowSize from '../../../hooks/bundle.esm3.js';
import { initialMeasures } from './bundle.esm2.js';
import OverlayStyled from './bundle.esm3.js';
import Backdrop from '../../Backdrop/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Overlay = forwardRef((props, ref) => {
  var _a;
  const { children, className, parentRef, position } = props;
  const { width: widthProp, isFixed, target, backdropConfig } = props;
  const { width } = useWindowSize();
  const targetIsFocus = target == null ? void 0 : target.includes("focus");
  const targetIsHover = target == null ? void 0 : target.includes("hover");
  const noShowBackdrop = targetIsFocus || targetIsHover;
  const overlayRef = useRef(null);
  const [parentMeasures, setParentMeasures] = useState(initialMeasures);
  const portalNode = usePortal("Overlay");
  useIsomorphicLayoutEffect(() => {
    var _a2;
    if (!(parentRef == null ? void 0 : parentRef.current))
      return;
    const measuresRect = (_a2 = parentRef.current) == null ? void 0 : _a2.getBoundingClientRect();
    if (!measuresRect)
      return;
    const measures = measuresRect == null ? void 0 : measuresRect.toJSON();
    if (!isFixed) {
      measures.y = measures.y + window.scrollY;
    }
    setParentMeasures(measures);
  }, [width]);
  if (!portalNode) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !noShowBackdrop ? /* @__PURE__ */ React.createElement(Backdrop, __spreadProps(__spreadValues({
    color: "transparent",
    opacity: 0,
    name: "Dropdown-backdrop"
  }, backdropConfig), {
    allowScroll: true,
    opened: true
  })) : null, createPortal(
    /* @__PURE__ */ React.createElement(OverlayStyled, {
      className: `Overlay ${className}`,
      measures: parentMeasures,
      position,
      width: widthProp != null ? widthProp : (_a = overlayRef == null ? void 0 : overlayRef.current) == null ? void 0 : _a.getBoundingClientRect().width
    }, Children.map(children, (child) => {
      if (!isValidElement(child)) {
        return child;
      }
      return cloneElement(child, {
        ref: overlayRef
      });
    })),
    portalNode
  ));
});
Overlay.defaultProps = {
  className: ""
};

export { Overlay as default };
//# sourceMappingURL=bundle.esm.js.map
